<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-21 17:02:29
 * @LastEditTime: 2020-11-17 11:06:44
-->
<template>
  <div v-if="dialogVisible">
     <el-dialog
      :title="$t('lang.usercontrol.userinfo')"
      :visible.sync="dialogVisible"
      width="40%"
      center>
      <div class="concen">
        <el-form :model="user" ref="userForm" label-width="150px" label-position="right" :rules="rules">
          <el-form-item :label="`${$t('lang.usercontrol.UserGroup')}：`" prop="username">
            <el-input
              size="mini"
              v-model="user.username"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Mandatory')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.userDisplay')}：`" prop="password">
            <el-input
              size="mini"
              v-model="user.password"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Mandatory')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.NICKNAME_RE')}：`">
            <el-input
              size="mini"
              v-model="user.nickname"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.FILE_REAL_H')}：`">
            <el-input
              size="mini"
              v-model="user.realname"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.user_admin')}：`" prop="roleid">
            <el-select
              v-model="user.roleid"
              :placeholder="$t('lang.usercontrol.choose')"
              class="adduserinput"
              clearable
              size="mini">
              <el-option
                v-for="item in roleId"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.users_grid')}：`" prop="user_iscustomer">
            <el-select
              v-model="user.user_iscustomer"
              :placeholder="$t('lang.usercontrol.choose')"
              class="adduserinput"
              size="mini"
              clearable>
              <el-option
                v-for="item in userlevel"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.phone')}：`" prop="user_tel">
            <el-input
              size="mini"
              v-model="user.user_tel"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Mandatory')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.socialize')}：`">
            <el-input
              size="mini"
              v-model="user.user_qq"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.address')}：`">
            <el-input
              size="mini"
              v-model="user.user_addr"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.notesData')}：`">
            <el-input
              size="mini"
              v-model="user.user_remarks"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.usercontrol.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="adduser">{{$t('lang.usercontrol.Determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { registerUser, getFunctionalAuthority } from "@/api/usercontrol";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import { rules, setLevel } from './formConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      //添加用户
      user: {
        username: "",
        password: "88888888a",
        nickname: "",
        realname: "",
        user_email: "",
        user_sex: 1,
        user_tel: "",
        user_icon: "",
        user_qq: "",
        user_addr: "",
        user_remarks: "",
        user_iscustomer: "",
        roleid: ""
      },
      userlevel: [],
      roleId: [],
      // 表单验证规则
      rules: rules
    }
  },
  methods: {
    show() {
      //获取权限列表
      getFunctionalAuthority(this.$i18n.locale == "en-US" ? 1 : 0).then(res => {
        this.roleId = res.data.data.list;
      });
      // 根据权限设置下拉框选项
      this.userlevel = setLevel()
      this.dialogVisible = true
    },
    adduser() {
      this.$refs.userForm.validate(valid => {
        if(valid) {
          if (this.user.user_iscustomer == this.$t("lang.usercontrol.usertype1")) {
            this.user.user_iscustomer = "0"
            this.$nextTick(()=>{
              this.user.user_iscustomer = this.$t("lang.usercontrol.usertype1")
            })
          } else if (
            (this.user.user_iscustomer == this.$t("lang.usercontrol.usertype3")) &
            (getuser_ctid() == 0)
          ) {
            this.user.user_iscustomer = "1";
            this.$nextTick(()=>{
              this.user.user_iscustomer=this.$t("lang.usercontrol.usertype3")
            })
          } else if (
            (this.user.user_iscustomer == this.$t("lang.usercontrol.usertype2")) &
            (getuser_ctid() != 0)
          ) {
            this.user.user_iscustomer = "1"
            this.user.user_iscustomer=this.$t("lang.usercontrol.usertype2")
          }
          // 添加接口
          registerUser(this.user).then(res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message1"),
                type: "success"
              });
              this.$emit('queryKeyword')
              this.dialogVisible = false
            } else if (res.data.code === 7) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message2"),
                type: "warning"
              });
            } else if (res.data.code === 8) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message3"),
                type: "warning"
              });
            } else if (res.data.code === 6) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message4"),
                type: "warning"
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message5"),
                type: "warning"
              });
            }
          })
        }else{
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.concen{
  display: flex;
  justify-content: center;
}
.adduserinput {
  width: 4rem;
}
</style>